import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogActions } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button, TextField, PasswordSetter } from '../components';
import { checkPassword } from '../util'

class ChangePasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
  }

  clearState = () => {
    this.setState({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
  }

  render() {
    const {
      classes, onCancel, onSubmit, open,
    } = this.props;
    const { oldPassword, newPassword, confirmPassword } = this.state;

    const dialogActions = [
      <Button
        key="cancel"
        label="Abbrechen"
        primary
        onClick={() => {
          this.clearState();
          onCancel();
        }}
      />,
      <Button
        key="submit"
        disabled={!checkPassword(newPassword)}
        label="Übernehmen"
        color="primary"
        onClick={() => {
          onSubmit(oldPassword, newPassword, confirmPassword);
        }}
      />,
    ];

    return (
      <Dialog
        open={open}
        fullWidth
        classes={{ paper: 'dialog-paper' }}
      >
        <DialogTitle className={classes.formDialogTitle}>Passwort ändern</DialogTitle>
        <div className={classes.contentStyle}>
          <form>
            <TextField
              autoComplete="current-password"
              type="password"
              label="Altes Passwort"
              value={oldPassword}
              onChange={e => this.setState({ oldPassword: e.target.value })}
              classes={{ root: classes.noMt }}
            />
            <PasswordSetter
              label="Neues Passwort setzen"
              value={newPassword}
              onChange={pw => this.setState({ newPassword: pw })}
              withGenerator
              canHidePassword
            />
            <PasswordSetter
              label="Neues Passwort bestätigen"
              value={confirmPassword}
              onChange={pw => this.setState({ confirmPassword: pw })}
              canHidePassword
            />
          </form>
        </div>
        <DialogActions>
          {dialogActions}
        </DialogActions>
      </Dialog>
    );
  }
}

ChangePasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  contentStyle: {
    padding: '0 20px 0 20px',
  },
  iconStyle: {
    marginTop: 25,
  },
  formDialogTitle: {
    background: theme.palette.primary.main,
    marginBottom: '14px !important',
    padding: '14px 20px 10px !important',
    color: theme.palette.primary.contrastText,
    textTransform: 'uppercase',
  },
  noMt: {
    marginTop: '0 !important',
  },
});

export default withStyles(styles)(ChangePasswordDialog);
